export class SiteModel {
    public Id: number;
    public AccountId: number = 0;
    public Name: string = "";
    public Address: string = "";
    public City: string = "";
    public PostalCode: string = "";
    public AdditionalLocationInfo: string = "";
    public PhoneNumber: string = "";
    public FaxNumber: string = "";
    public ContactPerson: string = "";
    public ContactPersonNumber: string = "";
    public CreatedDate: string = "";
    public LastUpdatedDate: string = "";
    public IsActive: boolean = true;
    public ObjectNumber: string = "";
    public IsDeleted: boolean = false;

    public FacebookLink: string;
    public InstagramLink: string;
    public YoutubeLink: string;
    public PublicEmailAddress: string;
    public PublicContactNumber: string;
    public CompanyLogo: string;
    public CompanyLogoBase64: string;
    public GDPRTitle: string;
    public GDPRContent: string;
    public Language: string;
}



// WEBPACK FOOTER //
// ./src/app/models/SiteModel.ts